export function fetchImpressions(state, { page, filter, sort, skipApiRequest }) {
  return {
    ...state,
    impressions: {
      ...state.impressions,
      currentPage: page,
      filter: filter || state.impressions.filter,
      sort: sort || state.impressions.sort,
      fetchingErrorMessage: '',
      isFetching: !skipApiRequest,
    },
  };
}

export function fetchImpressionsSuccess(state, impressions) {
  return {
    ...state,
    impressions: {
      ...state.impressions,
      numberOfPages: impressions.numberOfPages,
      count: impressions.count,
      items: impressions.items,
      isFetching: false,
      fetchingErrorMessage: '',
    },
  };
}

export function fetchImpressionsFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    impressions: {
      ...state.impressions,
      isFetching: false,
      fetchingErrorMessage: errorMessage,
    },
  };
}

export function openImpressionsCSVModal(state) {
  return {
    ...state,
    impressions: {
      ...state.impressions,
      showCSVModal: true,
    },
  };
}

export function closeImpressionsCSVModal(state) {
  return {
    ...state,
    impressions: {
      ...state.impressions,
      showCSVModal: false,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/impressions.js
 **/